function App() {
  window.location.assign("http://agendamiento.softwaremedilink.com/agendas/online/885efb1b88ba283f8406e8c1580c6272a617c1a7");
  return <div></div>;
}

export default App;
